import { SettingsTabName } from '@components/Settings/types';

const NCP_BASE = '/ncp';
export const LINKS_BASE_URL = '/links';
export const BUTTON_BASE_URL = '/buttons';
export const CART_BASE_URL = '/cart';
export const SETTINGS_BASE_URL = '/settings';
export const SUBSCRIPTIONS_BASE_URL = '/subscriptions';
export const LINK_EDITOR_AND_DETAILS_URL = `${NCP_BASE}${LINKS_BASE_URL}`;
export const BUTTON_EDITOR_AND_DETAILS_URL = `${NCP_BASE}${BUTTON_BASE_URL}`;
export const ADD_TO_CART_EDITOR_URL = `${NCP_BASE}${CART_BASE_URL}`;
export const SETTINGS_URL = `${NCP_BASE}${SETTINGS_BASE_URL}`;
export const SUBSCRIPTIONS_CREATE_PLAN_URL = `${NCP_BASE}${SUBSCRIPTIONS_BASE_URL}${LINKS_BASE_URL}`;
export const INITIAL_TAB_SEARCH_PARAM_KEY = 'initial_tab';
export const SETTINGS_URL_SINGLE_BUTTON_TAB = `${NCP_BASE}${SETTINGS_BASE_URL}?${INITIAL_TAB_SEARCH_PARAM_KEY}=${SettingsTabName.SINGLE_BUTTON}`;
export const SETTINGS_URL_STACKED_BUTTONS_TAB = `${NCP_BASE}${SETTINGS_BASE_URL}?${INITIAL_TAB_SEARCH_PARAM_KEY}=${SettingsTabName.STACKED_BUTTONS}`;
export const SETTINGS_URL_CART_BUTTONS_TAB = `${NCP_BASE}${SETTINGS_BASE_URL}?${INITIAL_TAB_SEARCH_PARAM_KEY}=${SettingsTabName.CART_BUTTONS}`;
export const SAVED_LINKS_AND_BUTTONS_URL = '/buttons/saved';
export const PAYPAL_LOGO_URL = 'https://www.paypalobjects.com/ncp/icon/paypal-mark-color-300.png';

// This mapping is for JSSDK, according to https://developer.paypal.com/sdk/js/configuration/#link-locale
export const JSSDK_SPECIAL_LOCALES_MAP: Record<string, string | undefined> = {
  'zh-CN-xbord': 'zh-CN',
  'en-CN-xbord': 'zh-CN',
  'nb-NO': 'no-NO',
  'fil-PH': 'en-PH'
};

// According to https://paypal.slack.com/archives/C02D21KRD45/p1693268291663499
export const BFS_SPECIAL_LOCALES_MAP: Record<string, string | undefined> = {
  'zh-CN-xbord': 'zh-C2',
  'en-CN-xbord': 'en-C2',
  'nb-NO': 'no-NO',
  'fil-PH': 'tl-PH'
};

export const ERRORS = {
  CART_OUT_OF_SYNC: 'Cart out of sync with server',
  INSUFFICIENT_INVENTORY: 'Insufficient Inventory'
};

// Modified version of this regex: https://uibakery.io/regex-library/url
// Updated to align with RFC 1034 label length rules.
// TLD length adjusted from {1,6} to {2,63}
export const URL_REGEX =
  /^((http|https)\:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{2,63}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
